import React, { Component } from 'react';
import { connect } from 'shalala';

import { useStore } from '../../../../store';
import SearchInput from '../../../../facturotopia/search-input/SearchInput';

class EmisoresSearch extends Component {
  handleOnKeywordChange = (keyword) => {
    const { filters } = this.props.list;

    this.props.paginate({
      ...filters,
      search: keyword,
    });
  };

  handleOnSearchClear = () => {
    this.handleOnKeywordChange('');
  };

  render() {
    const {
      filters: { search },
    } = this.props.list;

    return (
      <div className="d-flex flex-column flex-sm-row">
        <SearchInput
          onKeywordChange={this.handleOnKeywordChange}
          onClear={this.handleOnSearchClear}
          value={search}
        />
      </div>
    );
  }
}

const mapState = (store) => {
  return { list: store.app.emisores.list };
};

const mapActions = (actions) => {
  return actions.app.emisores.list;
};

export default connect(useStore, mapState, mapActions)(EmisoresSearch);
